import { render, staticRenderFns } from "./OrdenV2.vue?vue&type=template&id=ec64eb46&scoped=true&"
import script from "./OrdenV2.vue?vue&type=script&lang=js&"
export * from "./OrdenV2.vue?vue&type=script&lang=js&"
import style0 from "./OrdenV2.vue?vue&type=style&index=0&id=ec64eb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec64eb46",
  null
  
)

export default component.exports